import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#0077B6',
                secondary: '#06D6A0',
                black: '#343540',
                error: '#b71c1c',
            },
        },
    },
});
